import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stats",
  "use": "icon-stats-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stats\"><path d=\"M64 192h76.8v672H64z\" /><path d=\"M960 787.2V864H64v-76.8zm-723.2-76.8L185.6 672l224-275.2 198.4 160 288-313.6 51.2 44.8-332.8 358.4-192-160z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol